export default "__VITE_ASSET__eb540f59__"